// extracted by mini-css-extract-plugin
module.exports = {"coverLink":"Vf-z","contentBox":"Wf-z","zapposPromoContainer":"Xf-z","zapposPromoGroupContainer":"Yf-z","promos":"Zf-z","bottom":"_f-z","top":"ag-z","right":"bg-z","left":"cg-z"};